import StaticHeaderInfo from "components/pages/web/static/staticHeaderInfo";
import { Trans, useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { Row, Col, Container, Card, CardBody, CardTitle } from "reactstrap";

const Rules = () => {
  const { t } = useTranslation();

  const rulesItemsOne = [
    "Payment_services_website",
    "Coinnik_Market_Online_Store",
    "Telecommunication_systems",
    "Account_created",
    "Buyer_user_applicant",
    "User_ID",
    "Confidential_Information",
    "Laws_and_Regulations",
    "Rental_account",
    "Customer_authentication",
    "Authentication_law",
  ];
  const rulesItemsTwo = [
    "A- Sending a picture of the national card of the paying person in the form of a selfie (buyer-user)",
    "B- Sending the bank card that the buyer (user) intends to pay for by selfie.",
    "Note: In order to protect and secure the buyer, when sending a selfie image of his bank card, he should distort the date and CVV2 of his bank card in the sent image, and only the identity of the card owner and the card number should be legible.",
    "C- Providing a fixed and mobile contact number of the buyer, which must be confirmed during the sending of the telecommunication code.",
    "D - Do not use unauthorized IP (VPN) by buyers (users)",
    "E - Enter the email on the registration page: The email must be in the name and identity of the buyer.",
  ];
  const rulesItemsThree = [
    {
      title: "Order_registration",
      array: [
        "For_Order_registration",
        "Register_an_order_more_30_million",
        "Get_payment_confirmation",
        "User_pay_part",
      ],
    },
    {
      title: "Payment with a card that has not yet been verified:",
      array: [
        "Payment_with_card",
        "Card_belongs",
        "Card_does_not_belong",
        "The_card_belongs_use",
        "Card_verification",
      ],
    },
  ];
  const rulesItemsFour = [
    "Alternative_documents",
    "Rental_account_undertake",
    "Legal_age_correction",
    "All_fees_related",
    "Cancellation_orders",
  ];
  const rulesItemsFive = [
    {
      title: "Refund",
      array: [
        "If authentication is done:",
        "If the user's money is due to cancellation of the order: the settlement is without problems.",
        "If the user's money is due to the credit increase: settlement after 72 working hours is without problems.",
        "If not authenticated",
        "If the amount of the user's funds is less than 1 million: According to the support expert, it is possible to receive a certificate from the user.",
        "If the user's amount is more than 1 million: As long as the user authentication is not completed, neither customization nor refunds will be made.",
      ],
    },
  ];
  const rulesItemsSix = [
    "Cash_Currency_Income",
    "Settlement_request",
    "Ticket_Purchase",
    "Suspended_orders",
    "Currencies_Tag",
  ];
  const rulesItemsSeven = [
    "Ordering_process",
    "Website_Services",
    "Responsibility_all_actions",
    "Due_the_prevention",
    "Responsibility_consequences",
    "Using_services",
  ];

  return (
    <>
      <StaticHeaderInfo>
        <div className="title-style mb-5 mb-md-0">
          <span className="text-light fs-2 fw-bold ">
            {t("Terms and Conditions")}
          </span>
        </div>
      </StaticHeaderInfo>
      <Container>
        <Row className="my-3">
          <Col xs="12">
            <Card className="shadow mt-n5 mt-md-0">
              <CardBody>
                <Row className="py-3  flex-row-reverse ">
                  <Col xl="12">
                    <CardTitle className="mb-5">
                      <span className="title-bordre-bottom ">
                        {t(
                          "Terms, Conditions and Contracts for the Use of coinnik Market Services"
                        )}
                      </span>
                    </CardTitle>
                    <p className="text-secondary-two-light">
                      {t("Laws_and_regulations")}
                    </p>
                    <p className="text-secondary-seven-light fw-medium">
                      {t(
                        "The terms used in these Terms and Conditions have the following meanings:"
                      )}
                    </p>
                    <div className="list bullet-point">
                      <ul>
                        {rulesItemsOne.map((item) => (
                          <li className="text-secondary-two-light py-3">
                            <Trans
                              i18nKey={item}
                              components={[<span className="fw-medium" />]}
                            />
                          </li>
                        ))}
                      </ul>
                    </div>
                    {rulesItemsTwo.map((item) => (
                      <p>
                        <Trans
                          i18nKey={item}
                          components={[
                            <span className="text-danger-light fw-medium" />,
                          ]}
                        />
                      </p>
                    ))}
                    <div className="list bullet-point">
                      <ul>
                        <li className="text-secondary-two-light py-3">
                          <Trans
                            i18nKey="IP_of_Iran"
                            components={[<span className="fw-medium" />]}
                          />
                        </li>
                      </ul>
                    </div>
                    <div className="list bullet-point">
                      <ul>
                        {rulesItemsThree.map((item) => (
                          <li className="text-secondary-two-light py-3">
                            <Trans
                              i18nKey={item.title}
                              components={[<span className="fw-medium" />]}
                            />
                            {item.array.map((item) => (
                              <>
                                <br />
                                <span>
                                  <Trans
                                    i18nKey={item}
                                    components={[
                                      <span className="text-danger-light fw-medium" />,
                                    ]}
                                  />
                                </span>
                              </>
                            ))}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="list bullet-point">
                      <ul>
                        {rulesItemsFour.map((item) => (
                          <li className="text-secondary-two-light py-3">
                            <Trans
                              i18nKey={item}
                              components={[<span className="fw-medium" />]}
                            />
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="list bullet-point">
                      <ul>
                        {rulesItemsFive.map((item) => (
                          <li className="text-secondary-two-light py-3">
                            <Trans
                              i18nKey={item.title}
                              components={[<span className="fw-medium" />]}
                            />
                            {item.array.map((item) => (
                              <>
                                <br />
                                <span>
                                  <Trans
                                    i18nKey={item}
                                    components={[
                                      <span className="fw-medium" />,
                                    ]}
                                  />
                                </span>
                              </>
                            ))}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="list bullet-point">
                      <ul>
                        {rulesItemsSix.map((item) => (
                          <li className="text-secondary-two-light py-3">
                            <Trans
                              i18nKey={item}
                              components={[<span className="fw-medium" />]}
                            />
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="list">
                      <ul>
                        {rulesItemsSeven.map((item) => (
                          <li className="text-secondary-two-light py-3">
                            <Trans
                              i18nKey={item}
                              components={[
                                <span className="fw-medium text-danger-light" />,
                              ]}
                            />
                          </li>
                        ))}
                      </ul>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default Rules;
